module.exports = __webpack_public_path__ + "img/xzIco (5).43e13ee3.png";